import { Vue, Component } from 'vue-property-decorator';
import UserService from '@/services/user.service';
import TokenService from '@/services/token.service';
import { UserDTO } from '@/models/UserDTO';
import InputText from '@/components/inputs/InputText/InputText.vue';
import InputPassword from '@/components/inputs/InputPassword/InputPassword.vue';
import { McsisRole } from '@/models/constants/McsisRole';

@Component({
  components: {
    InputText,
    InputPassword,
  },
})
export default class UserIdentification extends Vue {
  // Properties
  public errorMessage: string = '';
  public username: string = '';
  public password: string = '';
  public showModal: boolean = false;
  public rolePharmacist: string = McsisRole[McsisRole.Pharmacist];
  public roleDoctor: string = McsisRole[McsisRole.Doctor];

  // Lifecycle hook
  public mounted() {
    this.errorMessage = '';
  }

  // Methods

  /**
   * Logs the professionnal user in.
   */
  protected async login() {
    const username = this.username;
    const password = this.password;
    this.errorMessage = '';

    const loginResponse = await UserService.login(username, password)
      .then((res: UserDTO) => {
        if (TokenService.tokenExists()) {
          this.$emit('authenticated', true);
          this.$store.commit('setIsAuthenticated', true);

          return res.suName;
        }
      })
      .catch((error: any) => {
        if (error.response === undefined) {
          return;
        }

        switch (error.response.status) {
          case 401:
            this.errorMessage = 'errorMgs.loginPage.incorrectUserNameOrPassword'; // translation key
            break;
          case 403:
            this.errorMessage = 'errorMgs.loginPage.accountLocked'; // translation key
            break;
          default:
            this.errorMessage = 'errorMgs.loginPage.authenticationError'; // translation key
        }
      });

    if (loginResponse !== undefined && this.$store.state.isAuthenticated) {
      await TokenService.generateXsrfToken().then((data: any) => {
        TokenService.setXsrfTokenInHeader();
        this.goToLogin(loginResponse);
      });
    }
  }

  protected goToLogin(suName: string | null): void {
    const su = suName !== null ? suName : this.$route.params.screening;
    this.$router.push({
      name: 'participant',
      params: {
        screening: su,
      },
    });
  }
}
